import SVG, { Props } from 'react-inlinesvg'
import { BlockComponent } from 'lib'

export const ReactInlineSvg: BlockComponent<Props> = props =>
	props.src ? <SVG width="100%" height="100%" uniquifyIDs={true} {...props} /> : <svg />

export type ReactInlineSvgProps = Props
